import { useGetLicenceByIdQuery } from "@sso/apis/licences";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";

import LicenceForm from "./licenceForm";

const LicenceEditDialog = () => {
  const { id } = useAppSelector(selectDialog);
  if (!id) {
    throw new Error("LicenceEditDialog: id is null");
  }
  const { data, isSuccess } = useGetLicenceByIdQuery(id);
  return <>{isSuccess && data && <LicenceForm licence={data} />}</>;
};

export default LicenceEditDialog;
